import { render, staticRenderFns } from "./PortraitSelect.vue?vue&type=template&id=88e8aa8a&scoped=true&"
import script from "./PortraitSelect.vue?vue&type=script&lang=js&"
export * from "./PortraitSelect.vue?vue&type=script&lang=js&"
import style0 from "./PortraitSelect.vue?vue&type=style&index=0&id=88e8aa8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e8aa8a",
  null
  
)

export default component.exports